import { Directive, OnInit } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { VirtualFolder } from '@modules/contacts/types/virtual-folder';
import { StateKey } from '@modules/settings/types/state-key';
import { ContactsContextMenuComponent } from '../components/contacts-context-menu/contacts-context-menu.component';
import { DPContextMenuDirective } from './dp-context-menu.directive';

@Directive({
  selector: '[appDPContactsContextMenu]',
  standalone: false,
})
export class ContactsContextMenuDirective
  extends DPContextMenuDirective<VirtualFolder, ContactsContextMenuComponent>
  implements OnInit
{
  protected override readonly application = Application.contacts;
  protected override readonly stateKey = StateKey.contactsDPSidebarFilters;

  protected override registerComponent() {
    return ContactsContextMenuComponent;
  }
}
